import startCase from 'lodash/startCase';
import toLower from 'lodash/toLower';
import { HCP } from '../constants/common';

const getFormattedCustomerType = (audienceName: string): string => {
  return audienceName?.toLowerCase() === HCP.toLowerCase()
    ? audienceName?.toUpperCase()
    : startCase(toLower(audienceName));
};

export default getFormattedCustomerType;
